<script>
	import { each, text, onMount } from "svelte/internal";

	export let type = "dualLine";
	export let id;
	export let row;
	export let dataCharts;

	$: key = row.measure;

	$: thisDualChart = [];
	$: categories = [];

	$: {
		dataCharts.columns
			.filter((e) => e.startsWith(key))
			.forEach((el, i) => {
				// thisDualChart[i] = Object.fromEntries([
				// 	[el, dataCharts.map((e) => e[el]).filter((e) => e)],
				// ]);
				categories[i] = el;
				thisDualChart[i] = dataCharts
					.map((e) => e[el])
					.filter((e) => e);
			});
	}
	// console.log(row, categories, thisDualChart);

	//Direct line labels
	$: decimalPlacesRaw = row?.decimalPlaces ?? row?.decimalPlace;
	$: decimalPlaces = Number.isFinite(+decimalPlacesRaw)
		? Math.max(0, Math.min(20, Math.trunc(+decimalPlacesRaw)))
		: 1;

	function formatWithDecimalPlaces(value) {
		const numberValue = +value;
		return Number.isFinite(numberValue)
			? numberValue.toFixed(decimalPlaces)
			: value;
	}

	$: textLabels = [];
	$: thisDualChart.forEach((d, i) => {
		textLabels[i] =
			formatWithDecimalPlaces(d[d.length - 1]) +
			(row.directLabelUnit?.includes("%")
				? i == 0
					? row.directLabelUnit
					: row.directLabelUnit2
				: i == 0
					? " " + row.directLabelUnit
					: " " + row.directLabelUnit2);
	});
	// console.log(textLabels);

	//Manually positioning labels where needed
	let dyAdjusts = [
		["lifeExpect-Females", -40],
		["lifeExpect-Males", 5],
		["unpaidWork-Females", -20],
		["unpaidWork-Males", -5],
		["feelingSafe-Males", -10],
		["protectedArea", -35],
		["protectedArea-sea", -45],
		["airPoll-urban", -5],
		["airPoll-rural", -40],
		["biodiversity-1", -7],
		["biodiversity-2", 7],
	];

	function getDyAdjust(cat) {
		let adjust = dyAdjusts.find((d) => d[0] == cat);
		if (adjust) {
			return adjust[1];
		} else {
			return 0;
		}
	}

	let max = row.yaxisend;
	let min = row.yaxisstart;
	let range = max - min;

	let chartWidth = 300,
		height = 110,
		offset = 35,
		rightPosition = 90;

	//Manually setting the margins where needed
	let offsets = [
		["feelingSafe", 65]
	];

	$: {
		offsets.forEach((d) => {
			d[0] == key ? (offset = d[1]) : (offset = offset);
		});
	}

	$: width = chartWidth - offset - rightPosition;

	let el;
	
	// Reformats mmm-yy strings (e.g. "Jan-25") to "Jan 2025" format
	function formatDate(dateStr) {
		if (!dateStr) return dateStr;

		const str = String(dateStr);

		const monthMap = {
			jan: "Jan",
			feb: "Feb",
			mar: "Mar",
			apr: "Apr",
			may: "May",
			jun: "June",
			jul: "July",
			aug: "Aug",
			sep: "Sept",
			oct: "Oct",
			nov: "Nov",
			dec: "Dec",
		};

		// Handle dd-mmm-yy format (e.g. "15-Jan-25") → "15 Jan 2025"
		const longMatch = str.match(/^(\d{1,2})-([A-Za-z]+)-(\d{2})$/);
		if (longMatch) {
			const month = monthMap[longMatch[2].toLowerCase()];
			const year = 2000 + parseInt(longMatch[3]);
			if (!month) return str;
			return `${parseInt(longMatch[1])} ${month} ${year}`;
		}

		// Handle mmm-yy format (e.g. "Jan-25") → "Jan 2025"
		const shortMatch = str.match(/^([A-Za-z]+)-(\d{2})$/);
		if (shortMatch) {
			const month = monthMap[shortMatch[1].toLowerCase()];
			const year =
				parseInt(shortMatch[2]) >= 30
					? 1900 + parseInt(shortMatch[2])
					: 2000 + parseInt(shortMatch[2]);
			if (!month) return str;
			return `${month} ${year}`;
		}

		return str;
	}

	$: formattedStartDate = formatDate(row.startdate);
	$: formattedEndDate = formatDate(row.enddate);
	$: formattedUpdated = formatDate(row.update);
</script>

<div class="graphic" {id} bind:this={el} bind:clientWidth={chartWidth}>
	<!-- Chart heading text -->
	<div class="chartContainer">
		<p class="headingText">{@html row.headingtext}</p>
		<!-- {#if key === "biodiversity"}
			<svg
				width=100%
				height="16"
				style="display:block; margin-bottom:4px"
			>
				<line
					x1="0"
					y1="8"
					x2="30"
					y2="8"
					stroke="rgb(32, 96, 149)"
					stroke-width="2.5"
					stroke-dasharray="8 4"
					stroke-linecap="butt"
				/>
				<text
					x="36"
					y="8"
					dominant-baseline="middle"
					font-size="13"
					fill="#333">Less smoothed</text
				>
			</svg>
		{/if} -->
	</div>

	<svg class="chartDrawing" width="281">
		<!-- This bit draws the chart background -->
		<rect class="chartBackground" x={offset} {width} {height}></rect>
		<!-- Y-axis -->
		<line
			x1={offset}
			x2={offset}
			y1="0"
			y2={height}
			stroke="black"
			stroke-width="0.5px"
		/>
		<line x1={offset - 5} x2={offset} y1="0" y2="0" stroke="grey" />
		<line
			x1={offset - 5}
			x2={offset}
			y1={height}
			y2={height}
			stroke="grey"
		/>
		<text
			x={offset - 5}
			y="0"
			fill="black"
			text-anchor="end"
			dominant-baseline="middle">{row.yaxisend}</text
		>
		<text
			x={offset - 5}
			y={height}
			fill="black"
			text-anchor="end"
			dominant-baseline="middle">{row.yaxisstart}</text
		>

		<!-- X-axis -->
		<!-- X-axis line (if desired)-->
		{#if !row.yaxisstart}
			<line
				x1={offset}
				x2={offset + width}
				y1={height}
				y2={height}
				stroke="lightgrey"
				stroke-width="3px"
			/>
		{/if}

		<line
			x1={offset + width}
			x2={offset + width}
			y1={height}
			y2="115"
			stroke="grey"
		/>
		<line x1={offset} x2={offset} y1={height} y2="115" stroke="grey" />
		<text
			class="startDate"
			x={offset}
			y={height}
			dy="1.5em"
			dominant-baseline="top">{formattedStartDate}</text
		>
		<text
			class="endDate"
			x={offset + width}
			y={height}
			dy="1.5em"
			dominant-baseline="top">{formattedEndDate}</text
		>

		<!-- Iterate through the data and do the lines and labels for each entry -->
		{#each thisDualChart as thisChart, linenumber}
			<!-- Data lines-->

			{#if categories[linenumber] === "biodiversity-2"}
				<polyline
					points={thisChart
						.map(
							(point, i) =>
								`${i * (width / (thisChart.length - 1)) + offset},${height - ((point - min) / range) * height}`,
						)
						.join(" ")}
					fill="none"
					stroke="rgb(32, 96, 149)"
					stroke-width="2.5px"
					stroke-linecap="butt"
					stroke-dasharray="8 4"
				/>
			{:else}
				{#each thisChart as point, i}
					<!-- Don't draw lines for missing values -->
					{#if +thisChart[i - 1] && +thisChart[i]}
						<line
							x1={(i - 1) * (width / (thisChart.length - 1)) +
								offset}
							x2={i * (width / (thisChart.length - 1)) + offset}
							y1={height -
								((thisChart[i - 1] - min) / range) * height}
							y2={height -
								((thisChart[i] - min) / range) * height}
							stroke={categories[linenumber].includes("Female")
								? "rgb(103, 73, 166)"
								: categories[linenumber].includes("Male")
									? "rgb(46, 161, 164)"
									: categories[linenumber].includes("sea")
										? "rgb(32, 96, 149)"
										: categories[linenumber].includes(
													"rural",
											  )
											? "rgb(135, 26, 91)"
											: categories[linenumber].includes(
														"urban",
												  )
												? "rgb(32, 96, 149)"
												: categories[linenumber] ===
													  "biodiversity-1"
													? "rgb(246, 96, 104)"
													: "rgb(17, 140, 123)"}
							stroke-width="2.5px"
							stroke-linecap={categories[linenumber] ===
							"biodiversity-2"
								? null
								: "round"}
							stroke-dasharray={categories[linenumber] ===
							"biodiversity-2"
								? "5"
								: null}
						/>

						<!-- Add a grey band for missing values -->
					{:else if linenumber == 0 && i !== 0}
						<rect
							x={(i - 1) * (width / (thisChart.length - 1)) +
								offset}
							y={0}
							width={width / (thisChart.length - 1)}
							{height}
							fill="rgba(217, 217, 217,0.5)"
						/>
					{/if}
				{/each}
			{/if}

			<!--dot and text label-->
			<circle
				cx={offset + width}
				cy={height -
					((thisChart[thisChart.length - 1] - min) / range) * height}
				r="3"
				fill={categories[linenumber].includes("Female")
					? "rgb(103, 73, 166)"
					: categories[linenumber].includes("Male")
						? "rgb(46, 161, 164)"
						: categories[linenumber].includes("sea")
							? "rgb(32, 96, 149)"
							: categories[linenumber].includes("rural")
								? "rgb(135, 26, 91)"
								: categories[linenumber].includes("urban")
									? "rgb(32, 96, 149)"
									: categories[linenumber] ===
											"biodiversity-1"
										? "rgb(246, 96, 104)"
										: categories[linenumber] ===
											  "biodiversity-2"
											? "rgb(32, 96, 149)"
											: "rgb(17, 140, 123)"}
			></circle>
			{#each textLabels[linenumber].split(" ") as word, i}
				<text
					class="endTextDual"
					x={offset + width - 10}
					y={height -
						((thisChart[thisChart.length - 1] - min) / range) *
							height}
					dy={14 * i + getDyAdjust(categories[linenumber])}
					fill={categories[linenumber].includes("Female")
						? "rgb(103, 73, 166)"
						: categories[linenumber].includes("Male")
							? "rgb(46, 161, 164)"
							: categories[linenumber].includes("sea")
								? "rgb(32, 96, 149)"
								: categories[linenumber].includes("rural")
									? "rgb(135, 26, 91)"
									: categories[linenumber].includes("urban")
										? "rgb(32, 96, 149)"
										: categories[linenumber] ===
											  "biodiversity-1"
											? "rgb(246, 96, 104)"
											: categories[linenumber] ===
												  "biodiversity-2"
												? "rgb(32, 96, 149)"
												: "rgb(17, 140, 123)"}
					text-anchor="start"
					dx="1em"
					dominant-baseline="middle"
					font-weight={i !== 0 ? 400 : 700}>{word}</text
				>
			{/each}
		{/each}
	</svg>
	<p class="updated">Updated: {formattedUpdated}</p>
</div>
